import { Link } from 'react-router-dom'
import { projectFinancialsCardModels } from './sorenProjectFinancialsCard.js'
import type { AriaChatDigest } from '../../api/ariaChat'

export default function SorenProjectFinancialsCard({
  digest,
}: {
  digest?: AriaChatDigest | null
}) {
  const models = projectFinancialsCardModels(digest)
  if (!models.length) return null

  return (
    <>
      {models.map((model, i) => (
        <div
          key={`${model.title}-${model.href || i}`}
          className="soren-project-financials"
          data-testid="soren-project-financials"
        >
          <h3 data-testid="soren-pf-title">{model.title}</h3>
          <ul className="soren-fact-list">
            <li data-testid="soren-pf-outstanding">
              <span>Outstanding</span>
              <strong>{model.outstanding}</strong>
            </li>
            <li data-testid="soren-pf-left-to-bill">
              <span>Left to bill</span>
              <strong>{model.left_to_bill}</strong>
            </li>
            <li data-testid="soren-pf-received">
              <span>Received</span>
              <strong>{model.received}</strong>
            </li>
            <li data-testid="soren-pf-retainage">
              <span>Retainage</span>
              <strong>{model.retainage}</strong>
            </li>
          </ul>
          {model.href ? (
            <Link className="cr-btn dark" data-testid="soren-open-project" to={model.href}>
              Open project
            </Link>
          ) : null}
        </div>
      ))}
    </>
  )
}
